import React, { useContext } from "react"
import Intercom from "react-intercom"

import { UserContext } from "@/contexts/SessionContext"
import { config } from "@/config"

export const IntercomWrapper = () => {
  const { session } = useContext(UserContext)
  const { user } = session
  // const { currentUser: user } = useSession()
  const userDetail = {
    name: user.firstname.concat(...[" ", user.lastname]),
    email: user.email,
    companies: [
      {
        // eslint-disable-next-line @typescript-eslint/camelcase
        company_id: user.customer.id,
        name: user.customer.customerName
      }
    ]
  }

  const appId = config.intercomAppId
  return <Intercom appID={appId} {...userDetail} />
}
